export default __webpack_public_path__ + "static/media/Aswin Augustine.b1136935.png";